import { render, staticRenderFns } from "./leftMain.vue?vue&type=template&id=63e21ef0&scoped=true"
import script from "./leftMain.vue?vue&type=script&lang=js"
export * from "./leftMain.vue?vue&type=script&lang=js"
import style0 from "./leftMain.vue?vue&type=style&index=0&id=63e21ef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e21ef0",
  null
  
)

export default component.exports